export default function initialState() {
    return {
        jobrole: {
            __loading__: false,
            __error__: null
        }
    };
}
